import { useDispatch, useSelector } from 'react-redux'
import { login } from 'lib/core/data/auth/login'
import { getError, getSlice } from 'lib/core/data/auth/login/selectors'

interface Options {
  onSuccess?: () => void
  onFailure?: () => void
}

export const useLogin = (options?: Options) => {
  const dispatch = useDispatch()
  const error = useSelector(getError)
  const { isFetching } = useSelector(getSlice)

  return {
    error: error,
    isFetching,

    login: (deps: {
      email: string
      password: string
      persistent?: boolean
    }): void => {
      dispatch(login({
        ...deps,
        onSuccess: options?.onSuccess,
        onFailure: options?.onFailure
      }))
    }
  }
}
